<script setup lang="ts">
import mixitPlusUrl from '@/assets/svg-new/loyality-logos/mixit-plus.svg?url'
import mixitClubUrl from '@/assets/svg-new/loyality-logos/mixit-club.svg?url'
import Button from '@/mixit-ui/components/button/Button.vue';
import BirdSkin from '../bird/BirdSkin.vue';
import Tag from '@/mixit-ui/components/misc/Tag.vue';

</script>

<template>
  <div class="flex flex-col gap-4 p-6 bg-white rounded-lg w-110 text-brown-600">
    <div class="p-2 flex flex-row gap-4 items-center">
      <span class="flex w-18 h-18 bg-yellow-100 rounded-full items-center justify-center">
        <BirdSkin class="w-auto h-13.5" />
      </span>
      <div class="flex flex-col gap-1">
        <strong class="font-roboto-slab text-sm">Martin Pospíchal</strong>
        <strong class="font-roboto-slab text-xs">martin.pospichal@gmail.com</strong>
      </div>
    </div>
    <div class="flex flex-col gap-1">
      <div class="bg-yellow-50 rounded-sm flex justify-between items-center px-4 py-3">
        <div class="pt-1 w-24.5">
          <img
            :src="mixitPlusUrl"
            class="w-full"
          >
        </div>
        <Tag
          label="Aktivní"
          severity="success"
          size="lg"
        />
      </div>
      <div class="bg-yellow-50 rounded-sm flex justify-between items-center px-4 py-3">
        <div class="pt-1 w-24.5">
          <img
            :src="mixitClubUrl"
            class="w-full"
          >
        </div>
        <Tag
          label="Neaktivní"
          severity="danger"
          size="lg"
        />
      </div>
    </div>
    <div class="gap-2 flex flex-col font-roboto-slab">
      <div class="flex flex-row gap-2 items-center">
        <i class="text-2xl mi-credits leading-0" />
        <strong class="flex-1 text-sm">1652 kreditů</strong>
      </div>
      <div class="flex flex-row gap-2 items-center">
        <i class="text-2xl mi-map-pin leading-0" />
        <strong class="flex-1 text-sm">Černokostelecká 604/116, 108 00 Praha 10</strong>
      </div>
    </div>
    <Button
      label="Můj účet"
      size="md"
    />
    <Button
      label="Odhlásit se"
      severity="danger-light"
      size="md"
      variant="text"
    />
  </div>
</template>